"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const adventures = [{
  id: 1,
  title: "3‑Day Small‑Group Ha Giang Loop",
  description: "Enjoy an Easy Rider experience with professional guides and intimate group sizes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_limestone_pass.png",
  badgeText: "from $228",
  badgeVariant: "outline" as const
}, {
  id: 2,
  title: "4‑Day Frontier Small‑Group Ha Giang",
  description: "A full Easy Rider experience offering extra time to explore hidden northern trails.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ma_pi_leng_valley_view.png",
  badgeText: "from $319",
  badgeVariant: "outline" as const
}, {
  id: 3,
  title: "5‑Day Frontier Small‑Group Journey",
  description: "Extended Easy Rider experience traveling through Ha Giang and Cao Bang in comfort.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/northern_vietnam_frontier_road.png",
  badgeText: "from $425",
  badgeVariant: "outline" as const
}];
export default function CraftedFloridaAdventures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224106" id="curated-journeys" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-6xl font-light tracking-tight text-foreground mb-4">Curated journey</h2>
          <p className="font-serif text-muted-foreground max-w-2xl mx-auto text-xl italic">Experience small‑group motorbike journeys through the Ha Giang Loop, crafted for travelers who value quality over crowds.</p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {adventures.map((adventure, i) => <Card key={adventure.id} data-index={i} className="group border-none shadow-none bg-transparent flex flex-col">
              <div className="relative overflow-hidden rounded-sm">
                <AspectRatio ratio={3 / 4}>
                  <img src={adventure.image} alt={adventure.title} className="object-cover w-full h-full transition-all duration-1000 ease-out group-hover:scale-105 group-hover:saturate-[0.8]" />
                </AspectRatio>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-500 bg-black/20 group-hover:opacity-100">
                  <span className="font-default text-white text-sm tracking-widest uppercase border-b border-white pb-1">Reserve Your Seat</span>
                </div>
                <div className="absolute top-4 right-4 opacity-100 transform transition-all duration-300 ease-out">
                  <Badge variant={adventure.badgeVariant} className="bg-background/80 backdrop-blur-sm border-foreground/10 text-foreground font-default text-xs px-3 py-1 rounded-none">
                    {adventure.badgeText}
                  </Badge>
                </div>
              </div>
              <CardContent className="pt-8 px-0 text-center flex-grow flex flex-col justify-start">
                <h3 className="font-default text-2xl font-light text-foreground mb-4 tracking-tight">
                  {adventure.title}
                </h3>
                <p className="font-serif text-muted-foreground line-clamp-3 leading-relaxed text-lg">
                  {adventure.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-none px-10 py-6 bg-secondary text-secondary-foreground hover:bg-secondary/90 transition-colors font-default uppercase tracking-widest text-xs">
            <Link to="https://frontiernorthvietnam.com/reserve-your-seat/">CHECK AVAILABILITY</Link>
          </Button>
        </div>
      </div>
    </section>;
}